var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36531 4.42982L8.90615 5.39892C9.39424 6.27349 9.1983 7.42078 8.42957 8.18951C8.42957 8.18951 7.49713 9.12196 9.18775 10.8126C10.8783 12.5032 11.8108 11.5708 11.8108 11.5708C12.5795 10.802 13.7268 10.6061 14.6014 11.0942L15.5705 11.635C16.8911 12.372 17.0471 14.224 15.8863 15.3848C15.1888 16.0823 14.3343 16.6251 13.3897 16.6609C11.7996 16.7212 9.09922 16.3187 6.3904 13.6099C3.68159 10.9011 3.27916 8.20069 3.33944 6.61058C3.37525 5.66601 3.91799 4.81154 4.61549 4.11403C5.77628 2.95324 7.6283 3.10921 8.36531 4.42982Z",
    stroke: "#1D1616",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.25dd1f11906cfea3107c23e41dd105bd.svg";
export { ForwardRef as ReactComponent };